export default __webpack_public_path__ + "c231411b08f4f87506ec34254892dfbe.png";